import { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { Clock, MapPin, ChevronRight, ArrowRight, Sparkles, Calendar, ShoppingCart, User, Percent, CalendarDays, Star, CheckCircle } from 'lucide-react';
import Navbar from './Navbar';
import Footer from './Footer';

const HOME_PERKS = [
  {
    icon: ShoppingCart,
    title: 'Pre-Order Products',
    desc: 'Order your supplements online for easy in-store pick up. Skip the line, grab and go.',
  },
  {
    icon: User,
    title: 'Personalized Vitamin Plan',
    desc: 'Get a custom vitamin & supplement plan tailored to your goals by our certified practitioners.',
  },
  {
    icon: Percent,
    title: 'Earn 5% Cashback',
    desc: 'Every session earns 5% cashback in store rewards — redeemable on vitamins, supplements & more.',
  },
  {
    icon: CalendarDays,
    title: '10% Off Every Wednesday',
    desc: 'Members get an exclusive 10% discount on all in-store purchases every Wednesday.',
  },
];

const HERO_IMAGE =
  'https://static.wixstatic.com/media/133859_430295303fe04dd3b57440c0d29d1183~mv2.jpg/v1/fill/w_1920,h_1080,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/20231225_082202_edited_edited.jpg';

const TEAM = [
  {
    name: 'Maria Wallace',
    title: 'Certified Holistic Health Practitioner',
    credentials: 'Bachelor of Science, Herbal Sciences',
    image:
      'https://static.wixstatic.com/media/133859_44f19613d5324cf4b510caa13039c4f0~mv2.jpg/v1/fill/w_514,h_686,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/IMG_20240703_162241070_edited_edited.jpg',
    badge:
      'https://static.wixstatic.com/media/133859_27dcde17c64a4222b2e5b61a87ce91d5~mv2.jpg/v1/fill/w_184,h_68,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/herbalist.jpg',
    badgeAlt: 'Certified Holistic Health Practitioner',
  },
  {
    name: 'Mark Johnson',
    title: 'Senior Health & Nutrition Specialist',
    credentials: '25+ Years Health & Nutrition Experience',
    image:
      'https://static.wixstatic.com/media/133859_0ca0d1855fef429282ba998753224126~mv2.jpg/v1/fill/w_514,h_686,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/20240628_143220_edited.jpg',
    badge:
      'https://static.wixstatic.com/media/133859_951b067b492c403dbfb0e4572a33553b~mv2.jpg/v1/fill/w_184,h_68,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/medical%20symbol.jpg',
    badgeAlt: 'Health & Nutrition Specialist',
  },
  {
    name: 'Kourtland Fletcher',
    title: 'ISSA Certified Nutritionist',
    credentials: 'ISSA Bodybuilding Specialist',
    image:
      'https://static.wixstatic.com/media/133859_6bb4dd8a2264459aab5377544d96db3d~mv2.jpg/v1/fill/w_514,h_686,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/20231227_091532%5B1%5D.jpg',
    badge:
      'https://static.wixstatic.com/media/133859_eff867303d6d479685ad4782f04e618d~mv2.png/v1/fill/w_184,h_68,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/ISSA-Fitness-Trainer.png',
    badgeAlt: 'ISSA Certified Nutritionist',
  },
];

const GALLERY = [
  {
    src: 'https://static.wixstatic.com/media/133859_0ca7282b1aec4cbebec6ecc87849b657~mv2.jpg/v1/fit/w_960,h_433,q_90,enc_avif,quality_auto/133859_0ca7282b1aec4cbebec6ecc87849b657~mv2.jpg',
    alt: 'Healthy Life Vitamins store interior',
  },
  {
    src: 'https://static.wixstatic.com/media/133859_e52f7adbe9f3421db269c571c76857e7f003.jpg/v1/fit/w_480,h_858,q_90,enc_avif,quality_auto/133859_e52f7adbe9f3421db269c571c76857e7f003.jpg',
    alt: 'Natural supplements and vitamins selection',
  },
  {
    src: 'https://static.wixstatic.com/media/133859_82212f502f5d4ae39347971d9a9f3443~mv2.jpg/v1/fit/w_480,h_1067,q_90,enc_avif,quality_auto/133859_82212f502f5d4ae39347971d9a9f3443~mv2.jpg',
    alt: 'Organic herbs and natural remedies',
  },
  {
    src: 'https://static.wixstatic.com/media/133859_85aa15cb48c74b95946a7895d72b1348f003.jpg/v1/fit/w_480,h_855,q_90,enc_avif,quality_auto/133859_85aa15cb48c74b95946a7895d72b1348f003.jpg',
    alt: 'Personal care and wellness products',
  },
  {
    src: 'https://static.wixstatic.com/media/133859_dfd5b7b53c4841e1979ac95060af2cf3~mv2.jpg/v1/fit/w_480,h_1066,q_90,enc_avif,quality_auto/133859_dfd5b7b53c4841e1979ac95060af2cf3~mv2.jpg',
    alt: 'Vitamin supplements collection',
  },
  {
    src: 'https://static.wixstatic.com/media/133859_b7a19ec03f65452497f4366e3e40d516~mv2.jpg/v1/fit/w_960,h_431,q_90,enc_avif,quality_auto/133859_b7a19ec03f65452497f4366e3e40d516~mv2.jpg',
    alt: 'Healthy Life Vitamins products on display',
  },
  {
    src: 'https://static.wixstatic.com/media/133859_97d30b642c294c4fbc4f0a0eef2d8ee4~mv2.jpg/v1/fit/w_960,h_433,q_90,enc_avif,quality_auto/133859_97d30b642c294c4fbc4f0a0eef2d8ee4~mv2.jpg',
    alt: 'Store shelves stocked with natural products',
  },
  {
    src: 'https://static.wixstatic.com/media/133859_012d4d9430d34f2480f9b058c9ebbe64~mv2.jpg/v1/fit/w_480,h_1065,q_90,enc_avif,quality_auto/133859_012d4d9430d34f2480f9b058c9ebbe64~mv2.jpg',
    alt: 'Natural remedies and supplements',
  },
  {
    src: 'https://static.wixstatic.com/media/133859_c499b00bbd1f47578860362501bed924~mv2.jpg/v1/fit/w_480,h_1068,q_90,enc_avif,quality_auto/133859_c499b00bbd1f47578860362501bed924~mv2.jpg',
    alt: 'Herbal products collection',
  },
  {
    src: 'https://static.wixstatic.com/media/133859_320032783160453d86c40a2489f3ad11~mv2.jpg/v1/fit/w_480,h_1065,q_90,enc_avif,quality_auto/133859_320032783160453d86c40a2489f3ad11~mv2.jpg',
    alt: 'Organic wellness products display',
  },
  {
    src: 'https://static.wixstatic.com/media/133859_0b1d79f5beed4ff8a8372c204ebc0ace~mv2.jpg/v1/fit/w_480,h_270,q_90,enc_avif,quality_auto/133859_0b1d79f5beed4ff8a8372c204ebc0ace~mv2.jpg',
    alt: 'Vitamins and mineral supplements',
  },
  {
    src: 'https://static.wixstatic.com/media/133859_962ec11382a14f6397c57f2e988e8950~mv2.jpg/v1/fit/w_480,h_269,q_90,enc_avif,quality_auto/133859_962ec11382a14f6397c57f2e988e8950~mv2.jpg',
    alt: 'Health and wellness products',
  },
  {
    src: 'https://static.wixstatic.com/media/133859_92b70fb8187447ee8488cb845d92199f~mv2.jpg/v1/fit/w_960,h_433,q_90,enc_avif,quality_auto/133859_92b70fb8187447ee8488cb845d92199f~mv2.jpg',
    alt: 'Montclair Village vitamin store interior',
  },
];

/* ── Scroll-reveal hook ── */
function useReveal() {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current) return;
    const el = ref.current;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('revealed');
          obs.disconnect();
        }
      },
      { threshold: 0.12 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return ref;
}

export default function HomePage() {
  const aboutRef = useReveal();
  const galleryRef = useReveal();
  const teamRef = useReveal();
  const servicesRef = useReveal();

  return (
    <div className="min-h-screen bg-[#F3F4F6] font-['Manrope']">
      {/* Scroll reveal styles injected inline */}
      <style>{`
        .reveal-section { opacity: 0; transform: translateY(32px); transition: opacity 0.7s ease, transform 0.7s ease; }
        .reveal-section.revealed { opacity: 1; transform: none; }
        .stagger-child { opacity: 0; transform: translateY(24px); transition: opacity 0.6s ease, transform 0.6s ease; }
        .revealed .stagger-child:nth-child(1) { opacity:1; transform:none; transition-delay: 0.05s; }
        .revealed .stagger-child:nth-child(2) { opacity:1; transform:none; transition-delay: 0.15s; }
        .revealed .stagger-child:nth-child(3) { opacity:1; transform:none; transition-delay: 0.25s; }
        .revealed .stagger-child:nth-child(4) { opacity:1; transform:none; transition-delay: 0.35s; }
        .gallery-masonry { columns: 3; column-gap: 8px; }
        @media (max-width: 900px) { .gallery-masonry { columns: 2; } }
        @media (max-width: 600px) { .gallery-masonry { columns: 2; column-gap: 4px; } }
        .gallery-masonry img { display: block; width: 100%; margin-bottom: 8px; break-inside: avoid; border-radius: 10px; }
        @media (max-width: 600px) { .gallery-masonry img { margin-bottom: 4px; border-radius: 6px; } }
      `}</style>

      <Navbar />

      {/* ── HERO ── */}
      <section
        data-testid="hero-section"
        className="relative min-h-screen flex items-end overflow-hidden"
        aria-label="Welcome to Healthy Life Vitamins"
      >
        {/* Background image */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url("${HERO_IMAGE}")` }}
          role="img"
          aria-label="Healthy Life Vitamins store interior in Montclair Village Oakland"
        />
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/30 to-black/10" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-transparent to-transparent" />

        {/* Store hours badge — top right */}
        <motion.div
          initial={{ opacity: 0, y: -12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8, duration: 0.5 }}
          className="absolute top-24 sm:top-28 right-4 sm:right-8 bg-white/90 backdrop-blur-sm rounded-2xl px-4 py-3 shadow-lg text-right"
          data-testid="hero-hours-badge"
        >
          <div className="flex items-center gap-1.5 text-[#1f3d2b] mb-1">
            <Clock size={13} />
            <span className="text-[10px] font-bold uppercase tracking-widest">Store Hours</span>
          </div>
          <p className="text-xs font-semibold text-gray-800 leading-relaxed">
            Mon–Sat <span className="text-[#1f3d2b]">10AM–6PM</span><br />
            Sunday <span className="text-[#1f3d2b]">11AM–5PM</span>
          </p>
        </motion.div>

        {/* Hero text */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 sm:pb-24 w-full">
          <motion.div
            initial="hidden"
            animate="visible"
            variants={{
              hidden: {},
              visible: { transition: { staggerChildren: 0.12 } },
            }}
            className="max-w-2xl"
          >
            <motion.div
              variants={{ hidden: { opacity: 0, y: 20 }, visible: { opacity: 1, y: 0 } }}
              className="inline-flex items-center gap-2 bg-[#d97736]/90 text-white text-xs font-bold uppercase tracking-widest px-3.5 py-1.5 rounded-full mb-5"
            >
              <MapPin size={11} />
              Montclair Village, Oakland CA
            </motion.div>

            <motion.h1
              variants={{ hidden: { opacity: 0, y: 28 }, visible: { opacity: 1, y: 0 } }}
              className="font-['Cormorant_Garamond'] text-5xl sm:text-6xl lg:text-7xl font-semibold text-white leading-tight mb-5"
            >
              We're here<br />for you
            </motion.h1>

            <motion.p
              variants={{ hidden: { opacity: 0, y: 20 }, visible: { opacity: 1, y: 0 } }}
              className="text-white/85 text-base sm:text-lg leading-relaxed mb-8 max-w-lg"
            >
              Montclair Village's premier destination for organic vitamins, potent herbs, and holistic wellness. Expert certified staff ready to support your health journey.
            </motion.p>

            <motion.div
              variants={{ hidden: { opacity: 0, y: 16 }, visible: { opacity: 1, y: 0 } }}
              className="flex flex-col sm:flex-row gap-3"
            >
              <a
                href="/wellness-suite"
                data-testid="hero-wellness-cta"
                className="inline-flex items-center justify-center gap-2 bg-[#1f3d2b] text-white font-semibold px-7 py-3.5 rounded-full hover:bg-[#2d5a3e] transition-all hover:-translate-y-px shadow-lg text-sm"
              >
                Explore Wellness Suite
                <ArrowRight size={15} />
              </a>
              <a
                href="/kiosk"
                data-testid="hero-kiosk-cta"
                className="inline-flex items-center justify-center gap-2 bg-white/15 backdrop-blur-sm text-white font-semibold px-7 py-3.5 rounded-full border border-white/30 hover:bg-white/25 transition-all text-sm"
              >
                <Sparkles size={15} />
                Get Supplement Advice
              </a>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* ── ABOUT / WELCOME ── */}
      <section
        data-testid="about-section"
        className="bg-white py-20 sm:py-28"
        id="about"
      >
        <div
          ref={aboutRef}
          className="reveal-section max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"
        >
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            {/* Text side */}
            <div className="stagger-child">
              <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#d97736] mb-4">
                Your Local Wellness Destination
              </p>
              <h2 className="font-['Cormorant_Garamond'] text-4xl sm:text-5xl font-semibold text-[#1f3d2b] leading-tight mb-6">
                Holistic health,<br />naturally curated
              </h2>
              <p className="text-gray-600 leading-relaxed mb-6 text-base sm:text-lg">
                Welcome to Healthy Life Vitamins, your premier destination for natural vitamins, potent herbs, and exceptional personal care products nestled in the heart of Montclair Village surrounded by thriving fitness centers.
              </p>
              <p className="text-gray-600 leading-relaxed mb-8 text-base">
                Embracing the essence of holistic wellness, we curate an exclusive selection of premium supplements and organic remedies, meticulously chosen to support your journey to optimal health. Whether you're a fitness enthusiast, wellness seeker, or simply dedicated to embracing a healthier lifestyle, our store is your haven.
              </p>

              {/* Feature highlights */}
              <div className="grid grid-cols-2 gap-4">
                {[
                  { icon: '🌿', label: 'Organic & Natural', desc: 'Carefully sourced products' },
                  { icon: '🎓', label: 'Expert Staff', desc: 'Certified practitioners' },
                  { icon: '🏡', label: 'Local & Community', desc: 'Montclair Village since day one' },
                  { icon: '✨', label: 'Wellness Sessions', desc: 'Personalized club sessions' },
                ].map((f) => (
                  <div key={f.label} className="flex gap-3 items-start">
                    <span className="text-xl mt-0.5">{f.icon}</span>
                    <div>
                      <p className="text-sm font-bold text-gray-800">{f.label}</p>
                      <p className="text-xs text-gray-500">{f.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-8 flex items-center gap-3">
                <a
                  href="#contact"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#1f3d2b] hover:gap-3 transition-all"
                >
                  Find us in Montclair Village
                  <ChevronRight size={15} />
                </a>
              </div>
            </div>

            {/* Image side */}
            <div className="stagger-child relative">
              <div className="relative rounded-3xl overflow-hidden shadow-2xl aspect-[4/5]">
                <img
                  src="https://static.wixstatic.com/media/133859_97d30b642c294c4fbc4f0a0eef2d8ee4~mv2.jpg/v1/fit/w_960,h_433,q_90,enc_avif,quality_auto/133859_97d30b642c294c4fbc4f0a0eef2d8ee4~mv2.jpg"
                  alt="Healthy Life Vitamins store shelves with natural products in Oakland"
                  className="w-full h-full object-cover"
                  loading="lazy"
                  referrerPolicy="no-referrer"
                />
              </div>
              {/* Floating badge */}
              <div className="absolute -bottom-5 -left-5 bg-[#1f3d2b] text-white rounded-2xl px-5 py-4 shadow-xl">
                <p className="text-2xl font-bold font-['Cormorant_Garamond']">25+</p>
                <p className="text-[10px] uppercase tracking-widest text-white/80">Years of Expertise</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── GALLERY ── */}
      <section
        data-testid="gallery-section"
        className="bg-[#F3F4F6] py-20 sm:py-28"
        id="gallery"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div ref={galleryRef} className="reveal-section">
            <div className="text-center mb-12 stagger-child">
              <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#d97736] mb-3">
                Our Store
              </p>
              <h2 className="font-['Cormorant_Garamond'] text-4xl sm:text-5xl font-semibold text-[#1f3d2b]">
                Visit us in Montclair
              </h2>
            </div>

            <div className="gallery-masonry stagger-child">
              {GALLERY.map((img, i) => (
                <img
                  key={i}
                  src={img.src}
                  alt={img.alt}
                  loading="lazy"
                  referrerPolicy="no-referrer"
                  className="hover:brightness-105 transition-all duration-300 hover:scale-[1.01]"
                  style={{ transitionOrigin: 'center' }}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── TEAM ── */}
      <section
        data-testid="team-section"
        className="bg-white py-20 sm:py-28"
        id="team"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div ref={teamRef} className="reveal-section">
            <div className="text-center mb-14 stagger-child">
              <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#d97736] mb-3">
                Expert Staff
              </p>
              <h2 className="font-['Cormorant_Garamond'] text-4xl sm:text-5xl font-semibold text-[#1f3d2b]">
                Meet the Team
              </h2>
              <p className="mt-4 text-gray-500 text-base max-w-xl mx-auto">
                Our certified practitioners bring decades of combined expertise in holistic health, nutrition, and wellness.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 lg:gap-10">
              {TEAM.map((member, i) => (
                <article
                  key={member.name}
                  data-testid={`team-card-${i}`}
                  className="stagger-child group bg-white rounded-3xl overflow-hidden shadow-sm border border-gray-100 hover:shadow-xl transition-shadow duration-500"
                >
                  {/* Photo */}
                  <div className="relative aspect-[3/4] overflow-hidden bg-gray-50">
                    <img
                      src={member.image}
                      alt={`${member.name} - ${member.title} at Healthy Life Vitamins Oakland`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                      loading="lazy"
                      referrerPolicy="no-referrer"
                    />
                    {/* Credential badge overlay */}
                    <div className="absolute bottom-3 left-3 right-3">
                      <img
                        src={member.badge}
                        alt={member.badgeAlt}
                        className="h-10 object-contain object-left rounded-lg opacity-90"
                        loading="lazy"
                        referrerPolicy="no-referrer"
                        onError={(e) => { e.target.style.display = 'none'; }}
                      />
                    </div>
                  </div>

                  {/* Text */}
                  <div className="p-5">
                    <h3 className="font-['Cormorant_Garamond'] text-2xl font-semibold text-[#1f3d2b]">
                      {member.name}
                    </h3>
                    <p className="text-sm font-semibold text-gray-700 mt-0.5">{member.title}</p>
                    <p className="text-xs text-gray-500 mt-1">{member.credentials}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── SERVICES / CTA ── */}
      <section
        data-testid="services-section"
        className="bg-[#F3F4F6] py-20 sm:py-28"
        id="services"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div ref={servicesRef} className="reveal-section">
            <div className="text-center mb-14 stagger-child">
              <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#d97736] mb-3">
                What We Offer
              </p>
              <h2 className="font-['Cormorant_Garamond'] text-4xl sm:text-5xl font-semibold text-[#1f3d2b]">
                Wellness, elevated
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 stagger-child">
              {/* Wellness Suite card */}
              <div
                data-testid="services-wellness-card"
                className="relative rounded-3xl overflow-hidden bg-[#1f3d2b] text-white p-8 sm:p-10 flex flex-col min-h-[340px]"
              >
                <div className="absolute inset-0 opacity-20"
                  style={{
                    backgroundImage: `url("${HERO_IMAGE}")`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}
                />
                <div className="relative z-10 flex flex-col h-full">
                  <div className="inline-flex items-center gap-2 bg-[#d97736] text-white text-xs font-bold uppercase tracking-widest px-3 py-1.5 rounded-full self-start mb-6">
                    <Calendar size={11} />
                    Now Booking
                  </div>
                  <h3 className="font-['Cormorant_Garamond'] text-3xl sm:text-4xl font-semibold mb-3">
                    Wellness Suite Sessions
                  </h3>
                  <p className="text-white/80 text-sm leading-relaxed flex-1">
                    Personalized recovery and wellness sessions tailored to your health goals. Single sessions, session packs, or a monthly membership — your journey, your pace.
                  </p>
                  <div className="mt-6 flex items-center gap-4 flex-wrap">
                    <span className="text-white/60 text-sm">From <strong className="text-white text-lg">$69</strong> / session</span>
                    <a
                      href="/wellness-suite"
                      data-testid="services-wellness-link"
                      className="inline-flex items-center gap-2 bg-white text-[#1f3d2b] text-sm font-bold px-6 py-2.5 rounded-full hover:bg-gray-100 transition-colors"
                    >
                      Learn More <ChevronRight size={14} />
                    </a>
                    <a
                      href="/booking"
                      data-testid="services-book-link"
                      className="inline-flex items-center gap-2 border border-white/40 text-white text-sm font-semibold px-5 py-2.5 rounded-full hover:bg-white/10 transition-colors"
                    >
                      Book Now <ArrowRight size={14} />
                    </a>
                  </div>
                </div>
              </div>

              {/* Supplement Advisor card */}
              <div
                data-testid="services-kiosk-card"
                className="relative rounded-3xl overflow-hidden bg-white border border-gray-100 p-8 sm:p-10 flex flex-col min-h-[340px] shadow-sm hover:shadow-lg transition-shadow duration-500"
              >
                <div className="w-12 h-12 rounded-2xl bg-[#d97736]/10 flex items-center justify-center mb-6">
                  <Sparkles size={22} className="text-[#d97736]" />
                </div>
                <h3 className="font-['Cormorant_Garamond'] text-3xl sm:text-4xl font-semibold text-[#1f3d2b] mb-3">
                  Supplement Advisor
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed flex-1">
                  Answer a few questions about your health goals, diet, and lifestyle. Our smart advisor will recommend the right vitamins and supplements specifically for you — powered by our expert team's knowledge.
                </p>
                <div className="mt-6">
                  <a
                    href="/kiosk"
                    data-testid="services-kiosk-link"
                    className="inline-flex items-center gap-2 bg-[#1f3d2b] text-white text-sm font-bold px-6 py-3 rounded-full hover:bg-[#2d5a3e] transition-colors"
                  >
                    Get Your Recommendations
                    <ArrowRight size={14} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── WELLNESS CLUB PERKS ── */}
      <section data-testid="home-perks-section" className="bg-[#1f3d2b] py-20 sm:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <div className="inline-flex items-center gap-2 bg-white/10 text-white text-xs font-bold uppercase tracking-[0.22em] px-4 py-2 rounded-full mb-5">
              <Star size={11} className="fill-[#d97736] text-[#d97736]" />
              Wellness Club Perks
            </div>
            <h2 className="font-['Cormorant_Garamond'] text-4xl sm:text-5xl font-semibold text-white mb-4">
              Members get more
            </h2>
            <p className="text-white/65 text-base max-w-lg mx-auto">
              Every monthly membership goes beyond sessions — exclusive rewards, discounts, and personalized care included.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {HOME_PERKS.map((perk, i) => (
              <div
                key={perk.title}
                data-testid={`home-perk-${i}`}
                className="bg-white/8 border border-white/10 rounded-3xl p-6 hover:bg-white/12 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-11 h-11 rounded-2xl bg-[#d97736]/20 flex items-center justify-center mb-5">
                  <perk.icon size={20} className="text-[#d97736]" />
                </div>
                <h3 className="font-semibold text-white text-base mb-2">{perk.title}</h3>
                <p className="text-white/60 text-sm leading-relaxed">{perk.desc}</p>
                <div className="mt-4 flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-widest text-[#d97736]">
                  <CheckCircle size={11} />
                  Included with Membership
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 text-center">
            <a
              href="/wellness-suite"
              data-testid="home-perks-cta"
              className="inline-flex items-center gap-2 bg-[#d97736] text-white font-semibold px-8 py-3.5 rounded-full hover:bg-[#b8662a] transition-all hover:-translate-y-px text-sm"
            >
              View All Membership Benefits
              <ArrowRight size={15} />
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
